//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      "default": "button"
    },
    disabled: {
      type: Boolean,
      required: true
    },
    hideTextOnXs: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      linkStyling: false
    };
  },
  methods: {
    $ready: function $ready() {
      var _this = this;

      this.$type.ifArray(this.spec.styleClasses, function (val) {
        _this.linkStyling = val.includes("link");
      });
    },
    styles: function styles() {
      var styles = this.genericStyles();

      if (this.linkStyling) {
        styles["color"] = styles["color"] || "#1976d2";
      }

      return styles;
    }
  }
};